import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronDown, faChevronUp } from "@fortawesome/free-solid-svg-icons";
import easel from "../assets/icons/easel.svg";

import "../styles/left-pane.css";

import useLeftPane from "../custom-hooks/useLeftPane";
import { SEMANTIC_SEARCH_FEATURE_ENABLED } from "../config/featureFlags";

const LeftPane = ({
  btn,
  setShow,
  setSearchResults,
  setSearchResultSets,
  setAnalytics,
  collNameIdentifier,
  collSourceCounts,
  collLocationCounts,
  searchString,
  setCurrentPage,
  setAnalyticsModalOpen,
  setLoading,
  filtersResetToken,
  setRagSummary,
}) => {
  const {
    dateVisible,
    locationVisible,
    collectionVisible,
    sourceVisible,
    fromYear,
    toYear,
    filters,
    toggleDate,
    toggleLocation,
    toggleCollection,
    toggleSource,
    handleFromYearChange,
    handleToYearChange,
    handleCollectionCheckboxChange,
    handleSourceCheckboxChange,
    handleLocationCheckboxChange,
    submitFilters,
    clearFilters,
    showMoreLocation,
    showMoreCollection,
    showMoreSource,
    handleAnalyticsClick,
    toggleMoreLocation,
    toggleMoreCollection,
    toggleMoreSource,
  } = useLeftPane({
    btn,
    setShow,
    setSearchResults,
    setSearchResultSets,
    setAnalytics,
    collNameIdentifier,
    collSourceCounts,
    collLocationCounts,
    searchString,
    setCurrentPage,
    setAnalyticsModalOpen,
    setLoading,
    filtersResetToken,
    setRagSummary: SEMANTIC_SEARCH_FEATURE_ENABLED ? setRagSummary : undefined,
  });

  const lang = localStorage.getItem("lang");
  const collNameField = lang === "ar" ? "coll_name_arabic" : "coll_name";
  const collLocationField =
    lang === "ar" ? "coll_location_arabic" : "coll_location";
  const collSourceField =
    lang === "ar" ? "coll_source_arabic" : "coll_source";

  const activeFilters = filters || {};

  const toggleArrow = (isVisible, toggle) => {
    if (isVisible) {
      return (
        <div className="arrow-div" onClick={toggle}>
          <FontAwesomeIcon icon={faChevronUp} className="arrow" />
        </div>
      );
    } else {
      return (
        <div className="arrow-div" onClick={toggle}>
          <FontAwesomeIcon icon={faChevronDown} className="arrow" />
        </div>
      );
    }
  };

  return (
    <>
      <div
        className="row g-0"
        style={{ display: "flex", alignItems: "center" }}
      >
        {btn ? (
          <button className="analytics-button" onClick={handleAnalyticsClick}>
            <img
              style={{
                width: "20px",
                height: "20px",
              }}
              alt=""
              src={easel}
            />
            <b>Analytics</b>
          </button>
        ) : (
          <div></div>
        )}
      </div>

      <hr className="horizontal-rule"></hr>

      <div className="row mb-2 g-0">
        <div className="col g-0">Date</div>
        <div
          className="col g-0 arrow"
          style={{ cursor: "pointer" }}
          onClick={toggleDate}
        >
          {toggleArrow(dateVisible, toggleDate)}
        </div>
      </div>
      {dateVisible && (
        <>
          <div className="row g-0">
            <div className="col g-0" style={{ fontWeight: "bold" }}>
              {" "}
              From{" "}
            </div>
            <div className="col g-0"></div>
            <div
              className="col g-0"
              style={{ fontWeight: "bold", transform: "translateX(-32px)" }}
            >
              {" "}
              To{" "}
            </div>
          </div>

          <div className="row g-0" style={{ display: "flex" }}>
            <div className="col g-0">
              <input
                type="text"
                placeholder="YYYY"
                onChange={handleFromYearChange}
                value={fromYear}
                style={{ width: "100px", outline: "none" }}
              />
            </div>
            <div
              className="col g-0"
              style={{
                display: "flex",
                justifyContent: "center",
                transform: "translateX(-15px",
              }}
            >
              {" "}
              -{" "}
            </div>
            <div className="col g-0">
              <input
                type="text"
                placeholder="YYYY"
                onChange={handleToYearChange}
                value={toYear}
                style={{
                  width: "100px",
                  transform: "translateX(-30px)",
                  outline: "none",
                }}
              />
            </div>
          </div>
        </>

        // <div className="row g-0">
        //   <div className="col g-0">
        //     <div className="col g-0" className="checkbox-label">From</div>
        //     <div className="col mb-2 g-0">
        //       <input
        //         type="text"
        //         placeholder="YYYY"
        //         onChange={handleFromYearChange}
        //         value={fromYear}
        //       />
        //     </div>
        //   </div>
        //   <div className="col g-0">
        //     <div className="col g-0" className="checkbox-label">To</div>
        //     <div className="col g-0" style={{ display: "flex" }}>
        //       <input
        //         type="text"
        //         placeholder="YYYY"
        //         onChange={handleToYearChange}
        //         value={toYear}
        //       />
        //     </div>
        //   </div>
        // </div>
      )}

      <hr className="horizontal-rule"></hr>

      <div className="row mb-2 g-0">
        <div className="col g-0">Place of Publication</div>
        <div className="col g-0" onClick={toggleLocation}>
          {toggleArrow(locationVisible, toggleLocation)}
        </div>
      </div>
      {locationVisible && (
        <div className="row g-0">
          <div className="col-pt-10 g-0">
            {/* Loop through collLocationCounts and display collection type and count */}
            {collLocationCounts &&
              collLocationCounts
                .slice(0, showMoreLocation ? collLocationCounts.length : 5)
                .map((collLocationCount, index) => {
                  const locationLabel =
                    collLocationCount[collLocationField] ??
                    collLocationCount.coll_location ??
                    collLocationCount.coll_location_arabic ??
                    "";
                  return (
                    <div
                      key={index}
                      style={{
                        display: "flex",
                        alignItems: "center",
                      }}
                    >
                      <input
                        type="checkbox"
                        className="format-checkboxes"
                        checked={
                          Array.isArray(activeFilters[collLocationField]) &&
                          activeFilters[collLocationField].includes(locationLabel)
                        }
                        onChange={(e) =>
                          handleLocationCheckboxChange(
                            e,
                            locationLabel
                          )
                        }
                      />
                      {/* <Checkbox
                            icon={
                              <div style={checkboxStyle}>
                                <FontAwesomeIcon icon={faCheck} height="10px" width="10px" size="lg" color="#fff"/>
                              </div>
                            }
                            name="my-input"
                            onChange={(e) =>
                              handleLocationCheckboxChange(
                                e,
                                collLocationCount.coll_location
                              )
                            }
                            size={14}
                            borderWidth={0}
                            style={{ borderRadius: "0", borderColor: "#CCC", backgroundColor: "#fff" }} />  */}

                      <label className="checkbox-label">
                        {locationLabel}
                      </label>

                      <span className="checkbox-count">
                        ({collLocationCount.count})
                      </span>
                    </div>
                  );
                })}
            {collLocationCounts.length > 5 && (
              <span className="more-span" onClick={toggleMoreLocation}>
                {showMoreLocation ? "Less..." : "More..."}
              </span>
            )}
          </div>
        </div>
      )}

      <hr className="horizontal-rule"></hr>

      <div className="row mb-2 g-0">
        <div className="col g-0">Collection</div>
        <div className="col g-0" onClick={toggleCollection}>
          {toggleArrow(collectionVisible, toggleCollection)}
        </div>
      </div>
      {collectionVisible && (
        <div className="row mt-2 g-0">
          <div className="col g-0">
            {collNameIdentifier &&
              collNameIdentifier
                .slice(0, showMoreCollection ? collNameIdentifier.length : 5)
                .map((collNameCount, index) => {
                  const collectionLabel =
                    collNameCount[collNameField] ??
                    collNameCount.coll_name ??
                    collNameCount.coll_name_arabic ??
                    "";
                  return (
                    <div
                      key={index}
                      style={{
                        display: "flex",
                        alignItems: "center",
                      }}
                    >
                      <input
                        type="checkbox"
                        className="format-checkboxes"
                        checked={
                          Array.isArray(activeFilters[collNameField]) &&
                          activeFilters[collNameField].includes(collectionLabel)
                        }
                        onChange={(e) =>
                          handleCollectionCheckboxChange(
                            e,
                            collectionLabel
                          )
                        }
                      />

                      {/* <Checkbox
                        icon={
                          <div style={checkboxStyle}>
                            <FontAwesomeIcon icon={faCheck} height="10px" width="10px" size="lg" color="#fff"/>
                          </div>
                        }
                        name="my-input"
                        onChange={(e) => handleCollectionCheckboxChange( e, collNameCount.coll_name )}
                        size={14}
                        borderWidth={0}
                        style={{ borderRadius: "0", borderColor: "#CCC", backgroundColor: "#fff" }}
                      /> */}

                      <label className="checkbox-label">
                        {collectionLabel}
                      </label>

                      <span className="checkbox-count">
                        ({collNameCount.count})
                      </span>
                    </div>
                  );
                })}

            {collNameIdentifier.length > 5 && (
              <span className="more-span" onClick={toggleMoreCollection}>
                {showMoreCollection ? "Less..." : "More..."}
              </span>
            )}
          </div>
        </div>
      )}

      <hr className="horizontal-rule"></hr>

      <div>
        <div className="row mb-2 g-0">
          <div className="col g-0">Source</div>
          <div className="col g-0" onClick={toggleSource}>
            {toggleArrow(sourceVisible, toggleSource)}
          </div>
        </div>
        {sourceVisible && (
          <div className="row mb-4 g-0">
            <div className="col g-0">
              {/* Loop through collSourceCounts and display collection type and count */}
              {collSourceCounts &&
                collSourceCounts
                  .slice(0, showMoreSource ? collSourceCounts.length : 5)
                .map((collSourceCount, index) => {
                  const sourceLabel =
                    collSourceCount[collSourceField] ??
                    collSourceCount.coll_source ??
                    collSourceCount.coll_source_arabic ??
                    "";
                  return (
                    <div
                      key={index}
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "start",
                        }}
                      >
                      <input
                        type="checkbox"
                        className="format-checkboxes"
                        checked={
                          Array.isArray(activeFilters[collSourceField]) &&
                          activeFilters[collSourceField].includes(sourceLabel)
                        }
                        onChange={(e) =>
                          handleSourceCheckboxChange(
                            e,
                            sourceLabel
                          )
                        }
                      />

                        {/* <Checkbox
                          icon={
                            <div style={checkboxStyle}>
                              <FontAwesomeIcon icon={faCheck} height="10px" width="10px" size="lg" color="#fff"/>
                            </div>
                          }
                          name="my-input"
                          onChange={(e) => handleSourceCheckboxChange( e, collSourceCount.coll_source )}
                          size={14}
                          borderWidth={0}
                          style={{ borderRadius: "0", borderColor: "#CCC", backgroundColor: "#fff" }}
                        />  */}

                        <label className="checkbox-label">
                          {sourceLabel}
                        </label>

                        <span className="checkbox-count">
                          ({collSourceCount.count})
                        </span>
                      </div>
                    );
                  })}

              {collSourceCounts.length > 5 && (
                <span className="more-span" onClick={toggleMoreSource}>
                  {showMoreSource ? "Less..." : "More..."}
                </span>
              )}
            </div>
          </div>
        )}
      </div>
      <div className="apply-clear-buttons row g-0">
        <button className="apply-button" onClick={submitFilters}>
          Apply Filters →
        </button>

        <button className="clear-button" onClick={clearFilters}>
          Clear Filters
        </button>
      </div>
    </>
  );
};

export default LeftPane;
